import React from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { Skeleton } from '@blade/ui-kit'
import { Numeric } from '@blade/ui-kit'

import type { Error } from '@root/shared'
import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type Props = {
  usdAmountState: AsyncStateN.AsyncStateN<Error.UnknownError, BigNumber>
} & ClassNameProps

export const AmountUsd: React.FC<Props> = ({ usdAmountState, className }) => {
  if (!AsyncStateN.isSuccess(usdAmountState)) {
    return <Skeleton height={12} width={80} />
  }

  return (
    <Root className={className}>
      ≈
      <Numeric
        value={usdAmountState.value.isNaN() ? 0 : usdAmountState.value}
        preset="currency-amount-short"
        currency="$"
      />
    </Root>
  )
}

const Root = styled.div`
  color: var(--text-9);
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
  overflow: hidden;

  text-align: left;
  margin-top: 4px;
`
